import _ from "lodash";

import { CompaniesHierarchyDataDto } from "../../../shared";

export const flattenCompanyChildren = (
  companyWithChildren: CompaniesHierarchyDataDto,
) => {
  let resultArray: CompaniesHierarchyDataDto[] = [companyWithChildren];
  if (companyWithChildren.childCompanies?.length > 0) {
    let childLevel =
      companyWithChildren.level !== undefined
        ? companyWithChildren.level + 1
        : 0;

    const sortedChildren = _.sortBy(
      companyWithChildren.childCompanies,
      (child) => child.name.toLowerCase(),
    );

    sortedChildren.forEach((childCompany: CompaniesHierarchyDataDto) => {
      childCompany = { ...childCompany, level: childLevel };
      flattenCompanyChildren(childCompany).forEach(
        (item: CompaniesHierarchyDataDto) => {
          resultArray.push(item);
        },
      );
    });
  }
  return resultArray;
};
